import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router'
import { Observable } from 'rxjs'
import { FirebaseAuthStateService } from './firebase-auth-state.service'
@Injectable({
    providedIn: 'root',
})
export class LoggedResolverService {
    private firebaseAuthState = inject(FirebaseAuthStateService)
    constructor() {}
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<any> | Observable<never> {
        return this.firebaseAuthState.user$
    }
}
